<vias-datagrid 
    [dgWidth]="dgWidth" 
    [dgHeight]="dgHeight" 
    [dataSource]="item.tableDataSource"
    [options]="datagridOptions"
    [columns]="dcolumns"
    [numLocale]="numLocale"
    [hasStateButtons]="false"
    [statusBarItems]="statusBarItems"
    [dgButtons]="dgButtons"
    (cellChange)="tableCellChange($event)"
    (rowClick)="tableClickHandler($event)"
    (dblClick)="tableDoubleClicked($event)"
    (selectClick)="tableSelectBtnClickHandler($event)"
    (selectChange)="tableSelectChangeHandler($event)"
    (addClick)="tableAddBtnClickHandler($event)"
    (editClick)="tableEditBtnClickHandler($event)"
    (deleteClick)="tableDeleteBtnClickHandler($event)"
>
</vias-datagrid><br/>
<vias-buttonbar
    [numLocale]="numLocale"
    [buttons]="item.tableButtonBarItems"
    (itemClick)="butonclickHandler($event)"
    *ngIf="item.hasTableButtonbar && (item.disabled === undefined || item.disabled === false)"
  ></vias-buttonbar><br/>